/**
 * Convert base64url string → ArrayBuffer
 * Handles missing padding automatically
 */
const base64UrlToArrayBuffer = (base64url) => {
  if (!base64url) throw new Error("base64url string is required");

  let base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
  const padLen = (4 - (base64.length % 4)) % 4;
  base64 += "=".repeat(padLen);

  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
};

/**
 * Convert ArrayBuffer / Uint8Array → base64url string (WebAuthn standard)
 * This is the ONE function you should use for all outgoing data
 */
const bufferToBase64Url = (buffer) => {
  if (!buffer) return null;
  const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
  
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, ""); // Remove padding
};

/**
 * Extract hostname from rpId (handles full URLs like https://abc.ngrok.io)
 */
const extractHostname = (rpIdOrUrl) => {
  if (!rpIdOrUrl) return window.location.hostname;
  try {
    return rpIdOrUrl.includes("://")
      ? new URL(rpIdOrUrl).hostname
      : rpIdOrUrl;
  } catch {
    return window.location.hostname;
  }
};

// Helper function to convert base64url to base64
const base64UrlToBase64 = (base64url) => {
  let base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
  const padding = base64.length % 4;
  if (padding) {
    base64 += '='.repeat(4 - padding);
  }
  return base64;
};

// Helper function to convert Uint8Array to standard base64 (no URL-safe changes)
const uint8ArrayToStandardBase64 = (bytes) => {
  return btoa(String.fromCharCode(...bytes))
  .replace(/\+/g, '-')
  .replace(/\//g, '_')
  .replace(/=/g, '');
};

// Helper function to convert base64 to Uint8Array
const base64ToUint8Array = (base64String) => {
  try {
    // Handle both base64 and base64url
    const base64 = base64UrlToBase64(base64String);
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  } catch (error) {
    console.error('Error converting base64 to Uint8Array:', error);
    throw new Error('Failed to decode base64 string');
  }
};

export { base64UrlToArrayBuffer, bufferToBase64Url, extractHostname, base64UrlToBase64, uint8ArrayToStandardBase64, base64ToUint8Array };